import {isFunction, isString} from "lodash";

import {selectKeywords} from "../../constant/selectors";

import {itemsCollection} from "../../constant";
import {startLoading, hasError} from "./keyword.slice";

import {keywordsCollection, LIMIT_KEYWORD_PER_DOC} from "src/constant";


export const createKeyword = (item, callback = null) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startLoading())

            const {raw = [], lastDoc = null} = selectKeywords(getState())

            const createAction = async () => {
                const newDoc = await keywordsCollection.add({
                    keyWords: [item]
                })
                

                await keywordsCollection.doc('RefKeyWord').set({
                    key: newDoc?.id
                }, {merge: true})

                await itemsCollection.doc(item.id).set({
                    keyWordsId: newDoc?.id
                }, {merge: true});
            }

            if (isString(lastDoc)) {
                const currentDocData = raw.filter(({docId}) => docId === lastDoc)
                const formatted = currentDocData.map(({docId, ...rest}) => ({...rest}))
                const newData = [...formatted, item]
                const hasReachLimit = currentDocData.length >= LIMIT_KEYWORD_PER_DOC;

                if (hasReachLimit) {
                    await createAction()
                } else {
                    await keywordsCollection.doc(lastDoc).update({
                        keyWords: newData,
                    })
                    
                    await itemsCollection.doc(item.id).set({
                        keyWordsId: lastDoc
                    }, {merge: true});
                }
            } else {
                await createAction()
            }

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}


export const updateKeyword = (item, callback = null) => {
    return async (dispatch, getState) => {
        try {
            dispatch(startLoading())

            const {raw = []} = selectKeywords(getState())
            const selectedDoc = raw.find(one => one?.id === item?.id);

            if (selectedDoc) {

                const keyWords = raw
                    .filter(({docId}) => docId === selectedDoc?.docId)
                    .map(one => (item?.id === one?.id) ? item : one)
                    .map(({docId, ...rest}) => ({...rest}));

                await keywordsCollection.doc(selectedDoc?.docId).update({keyWords})

            } else {
                dispatch(createKeyword(item))
            }

            isFunction(callback) && callback()

        } catch (error) {
            dispatch(hasError(error))
        }
    }
}